(ns app.front.view.group.admin.conditions.core
  (:require [app.domain.application.condition.model :as condition-model]
            [app.domain.util :as du]
            [app.front.entities :as entities]
            [app.front.ui.dnd :as dnd]
            [app.front.util :as futil]
            [app.front.view.conditions.common :as condition-common]
            [app.front.view.group.admin.common :as acommon]
            [app.front.view.group.admin.conditions.subs :as condition-subs]
            [app.front.view.group.admin.feature-toggle :as feature-toggle]
            [app.front.view.group.admin.subs :as gas]
            [app.front.view.not-found :as not-found]
            [core.front.carbon :as cc]
            [core.front.event :refer [<sub >evt]]
            [core.front.feature-flags :as ff]
            [core.front.icons :as i]
            [core.util.util :as util]
            [re-frame.core-instrumented :as rf]
            [schema.core :as s]))

(rf/reg-event-fx ::init
  (fn [_ [_ group-id]]
    {:fx [[:dispatch [::condition-subs/fetch-templates group-id]]]}))

(rf/reg-event-fx ::cleanup
  (fn [{:keys [db]} _]
    {:db (dissoc db ::data)}))

(rf/reg-event-fx ::save-new-button-clicked
  (fn [{:keys [db]} [_ group-id id]]
    (let [fields (get-in db [::data :fields id])]
      {:comm/command {:command    :group/create-condition-template
                      :method     :post
                      :data       {:authority-group-id group-id
                                   :data               fields}
                      :on-success [::create-template.success]}})))

(rf/reg-event-fx ::create-template.success
  (fn [{:keys [db]} [_ status changes]]
    {:db (update db ::data dissoc :show-new-template-form? :fields)
     :fx [[:dispatch [::entities/apply-changes status changes]]]}))

(defn- stop-editing-template
  [db id]
  (-> db
      (update-in [::data :editing-ids] disj id)
      (update-in [::data :fields] dissoc id)))

(rf/reg-event-fx ::save-edit-button-clicked
  (fn [{:keys [db]} [_ group-id id]]
    (let [fields (get-in db [::data :fields id])]
      {:comm/command {:command    :group/edit-condition-template
                      :method     :post
                      :data       {:authority-group-id group-id
                                   :template-id        id
                                   :data               fields}
                      :on-success [::edit-template.success id]}})))

(rf/reg-event-fx ::edit-template.success
  (fn [{:keys [db]} [_ id status changes]]
    {:db (stop-editing-template db id)
     :fx [[:dispatch [::entities/apply-changes status changes]]]}))

(rf/reg-event-fx ::delete-button-clicked
  (fn [_ [_ group-id id]]
    {:comm/command {:command    :group/delete-condition-template
                    :method     :post
                    :data       {:authority-group-id group-id
                                 :template-id        id}
                    :on-success [::delete-template.success id]}}))

(rf/reg-event-fx ::delete-template.success
  (fn [{:keys [db]} [_ id status changes]]
    {:db (stop-editing-template db id)
     :fx [[:dispatch [::entities/apply-changes status changes]]]}))

(rf/reg-event-fx ::add-button-clicked
  (fn [{:keys [db]} _]
    {:db (assoc-in db [::data :show-new-template-form?] true)}))

(rf/reg-event-fx ::cancel-new-button-clicked
  (fn [{:keys [db]} _]
    {:db (update db ::data dissoc :show-new-template-form? :fields)}))

(rf/reg-event-fx ::reorder-button-clicked
  (fn [{:keys [db]} _]
    {:db (assoc-in db [::data :reordering?] true)}))

(rf/reg-event-fx ::done-button-clicked
  (fn [{:keys [db]} _]
    {:db (update db ::data dissoc :reordering?)}))

(rf/reg-event-fx ::edit-button-clicked
  (fn [{:keys [db]} [_ id]]
    {:db (update-in db [::data :editing-ids] (fnil conj #{}) id)}))

(rf/reg-event-fx ::cancel-edit-button-clicked
  (fn [{:keys [db]} [_ id]]
    {:db (stop-editing-template db id)}))

(rf/reg-event-fx ::field-modified
  (fn [{:keys [db]} [_ id field val]]
    {:db (assoc-in db [::data :fields id field] val)}))



(rf/reg-event-fx ::reorder
  (fn [_ [_ group-id new-order]]
    {:comm/command {:command    :group/reorder-condition-template
                    :data       {:reorder-templates  new-order
                                 :authority-group-id group-id}
                    :on-success [::entities/apply-changes]}}))

(rf/reg-sub ::group-id
  :<- [:route/match]
  :-> (comp :group-id :path :parameters))

(rf/reg-sub ::templates
  :<- [::group-id]
  (fn [group-id _]
    (<sub [::condition-common/templates-for-group group-id])))

(rf/reg-sub ::template-ids
  :<- [::templates]
  (fn [templates]
    (->> templates
         (map :db/id))))

(rf/reg-sub ::template-map
  :<- [::templates]
  :-> du/entities->entity-db)

(rf/reg-sub ::template
  :<- [::template-map]
  (fn [templates [_ id]]
    (get templates id)))

(rf/reg-sub ::template-field
  (fn [[_ id]]
    (rf/subscribe [::template id]))
  (fn [template [_ _id field]]
    (get template field)))

(rf/reg-sub ::data
  :-> ::data)

(rf/reg-sub ::show-new-template-form?
  :<- [::data]
  :-> (comp boolean :show-new-template-form?))

(rf/reg-sub ::reordering?
  :<- [::data]
  :-> (comp boolean :reordering?))

(rf/reg-sub ::show-add-template-button?
  :<- [::reordering?]
  :-> not)

(rf/reg-sub ::editing-ids
  :<- [::data]
  :-> (comp set :editing-ids))

(rf/reg-sub ::editing-id?
  :<- [::editing-ids]
  (fn [ids [_ id]]
    (contains? ids id)))

(rf/reg-sub ::modified-fields
  :<- [::data]
  (fn [data [_ id]]
    (get-in data [:fields id])))

(rf/reg-sub ::entity-fields
  (fn [[_ id]]
    (rf/subscribe [::entities/entity id]))
  (fn [entity _]
    (select-keys entity condition-model/condition-template-editable-keys)))

(rf/reg-sub ::current-fields
  (fn [[_ id]]
    (rf/subscribe [::modified-fields id]))
  (fn [fields [_ id]]
    (if (= :new id)
      fields
      (merge (<sub [::entity-fields id])
             fields))))

(rf/reg-sub ::current-field-value
  (fn [[_ id _field]]
    (rf/subscribe [::current-fields id]))
  (fn [fields [_ _id field]]
    (get fields field)))

(rf/reg-sub ::fields-valid?
  (fn [[_ id]]
    (rf/subscribe [::current-fields id]))
  :-> condition-model/valid-condition-template?)

(rf/reg-sub ::fields-modified?
  (fn [[_ id _field]]
    [(rf/subscribe [::entity-fields id])
     (rf/subscribe [::current-fields id])])
  (fn [[original-fields current-fields]]
    (not= original-fields current-fields)))

(rf/reg-sub ::can-save?
  (fn [[_ id]]
    [(rf/subscribe [::fields-valid? id])
     (rf/subscribe [::fields-modified? id])])
  (fn [[valid? modified?]]
    (and valid? modified?)))

(rf/reg-sub ::can-delete?
  :<- [::group-id]
  (fn [group-id [_ id]]
    (let [in-use (<sub [::condition-subs/templates-in-use-for-group group-id])]
      (not (contains? in-use id)))))

(def ->template-field
  {:application.condition/title                :application.condition.template/title
   :application.condition/body                 :application.condition.template/body
   :application.condition/attachment-required? :application.condition.template/attachment-required?})

(defn- add-template-form
  [tr]
  (let [template-id :new
        group-id    (<sub [::group-id])]
    [condition-common/condition-editor-view
     (util/mmap {:id               template-id
                 :creating-new?    true
                 :default-group-id group-id
                 :can-save?        (<sub [::fields-valid? template-id])
                 :save-tr-key      :condition.template/add
                 :get-field        (fn [id field] (<sub [::current-field-value id (->template-field field)]))
                 :set-field        (fn [id field val] (rf/dispatch-sync [::field-modified id (->template-field field) val]))
                 :on-save          #(>evt [::save-new-button-clicked group-id template-id])
                 :on-cancel        #(>evt [::cancel-new-button-clicked])
                 :show-attachment-required?
                 (<sub [::ff/enabled? :feature-flag.id/planning-condition-attachments])}
                tr)]))

(defn- add-template-button
  [tr]
  (cc/button
    {:kind             :primary
     :icon             i/plus
     :icon-description (tr [:condition.template/add])
     :on-click         #(>evt [::add-button-clicked])}
    (tr [:condition.template/add])))

(defn- reorder-buttons
  [tr]
  (if (<sub [::reordering?])
    (cc/button {:kind     :primary
                :icon     i/remove
                :on-click #(>evt [::done-button-clicked])}
               (tr [:done]))
    (cc/button {:kind     :tertiary
                :icon     i/arrows-up-down
                :on-click #(>evt [::reorder-button-clicked])}
               (tr [:condition.template/reorder]))))

(defn- condition-row
  [{:keys [tr id index reordering? augment-target-props augment-draggable-props]}]
  (if (<sub [::editing-id? id])
    (let [group-id (<sub [::group-id])]
      [condition-common/condition-editor-view
       (util/mmap {:default-group-id group-id
                   :can-save?        (<sub [::can-save? id])
                   :can-delete?      (<sub [::can-delete? id])
                   :save-tr-key      :condition.template/save
                   :get-field        (fn [id field] (<sub [::current-field-value id (->template-field field)]))
                   :set-field        (fn [id field val] (rf/dispatch-sync [::field-modified id (->template-field field) val]))
                   :on-save          #(>evt [::save-edit-button-clicked group-id id])
                   :on-cancel        #(>evt [::cancel-edit-button-clicked id])
                   :on-delete        #(>evt [::delete-button-clicked group-id id])
                   :show-attachment-required?
                   (<sub [::ff/enabled? :feature-flag.id/planning-condition-attachments])}
                  id tr)])
    [condition-common/condition-row
     (util/mmap {:item         id
                 :item->body   (fn [id] (<sub [::template-field id :application.condition.template/body]))
                 :item->title  (fn [id] (<sub [::template-field id :application.condition.template/title]))
                 :item->attachment-required?
                 (fn [id] (and (<sub [::ff/enabled? :feature-flag.id/planning-condition-attachments])
                               (<sub [::template-field id :application.condition.template/attachment-required?])))
                 :border-color "border-ui-green"
                 :can-edit?    true
                 :can-reorder? true
                 :on-edit      (fn [id] (>evt [::edit-button-clicked id]))}
                id index tr reordering? augment-target-props augment-draggable-props)]))

(defn- template-list
  [tr]
  (let [group-id    (<sub [::group-id])
        ids         (<sub [::template-ids])
        reordering? (<sub [::reordering?])]
    [:<>
     [condition-common/header-row (util/mmap {:title     (tr [:condition.template/list])
                                              :row-count (count ids)})]
     [dnd/wrap-dnd
      {:id               (str "group-template-dnd-" group-id)
       :items            ids
       :props-for-source {:class "translate-x-2"}
       :on-reorder       (fn [from to] (>evt [::reorder group-id (util/mmap from to)]))}
      (fn [{:keys [sorted] :as draggable-props}]
        (futil/for-frag-indexed [[index id] sorted]
          ^{:key id}
          [condition-row (merge (util/mmap index id tr reordering?)
                                (select-keys draggable-props
                                             [:augment-target-props :augment-draggable-props]))]))]]))

(defn- conditions-config
  [match]
  (let [tr (<sub [::gas/group-tr])]
    [acommon/admin-page
     {:match match
      :tr    tr
      :title (tr [:group-admin/conditions])}
     (when (ff/enabled? :feature-flag.id/condition-due-dates)
       [acommon/section
        {}
        [feature-toggle/toggle-group-feature (merge (util/mmap tr)
                                                    {:feature-name :group.feature/condition-due-date})]])
     [acommon/section
      {:title (tr [:condition.template/templates])}
      [:<>
       [template-list tr]
       [:div.mt-4
        (if (<sub [::show-new-template-form?])
          [add-template-form tr]
          [:div.flex.gap-x-2
           (when (<sub [::show-add-template-button?])
             [add-template-button tr])
           [reorder-buttons tr]])]]]]))

(defn view
  [match]
  (let [group-id (<sub [::group-id])]
    (if (<sub [::condition-subs/fetching-templates-for-group? group-id])
      (cc/loading-spinner)
      (if (or (<sub [::condition-common/general-conditions-enabled-for-group? group-id])
              (<sub [::condition-common/default-conditions-enabled-for-group? group-id]))
        [conditions-config match]
        [not-found/not-found-view]))))

(def route
  {:name        :view/group.admin.conditions
   :view        view
   :parameters  {:path {:group-id s/Int}}
   :controllers [{:parameters {:path [:group-id]}
                  :start      (fn [params]
                                (>evt [::init (-> params :path :group-id)]))
                  :stop       (fn []
                                (>evt [::cleanup]))}]})
